import React from 'react';
import classNames from 'classnames/bind';
import { numbersList } from 'sections/Company/ContactUs/data';
import { Number } from 'sections/Company/ContactUs/types';
import styles from 'sections/Company/ContactUs/components/Contact/Numbers/Numbers.module.scss';

const cn = classNames.bind(styles);

const Numbers = (): React.ReactElement => {
  const numbersElements = numbersList.map((number: Number) => {
    return (
      <li
        className={cn('numbers__item')}
        key={number.code}
      >
        <i className={cn('numbers__flag', 'flag-icon', `flag-icon-${number.code}`)} />
        <a
          className={cn('numbers__link')}
          href={`tel:${number.phone}`}
        >
          {number.phone}
        </a>
      </li>
    );
  });

  return (
    <ul className={cn('numbers')}>
      {numbersElements}
    </ul>
  );
};

export { Numbers };
